import { ControllerCreditCard } from '@/features/profile/types';
import Payment from '@/model/Payment';
import React, { JSX } from 'react';
import { CardCheckout } from '../types';
import { CardCheckoutContent } from './CardCheckoutContent';

interface StateProps {
  id: string;
  payment: Payment;
  card: CardCheckout;
  totalValue: number;
  showValue: boolean;
  controllerCreditCard: ControllerCreditCard;
}

interface DispatchProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => void;
  toCurrency: (value: number) => string;
  onCardSelected: (id: string) => void;
  validateCreditCard: () => void;
}

type Props = StateProps & DispatchProps;

export const CreditCardPaymentRequestContent: React.FC<Props> = ({
  id,
  card,
  payment,
  totalValue,
  showValue,
  onChange,
  toCurrency,
  controllerCreditCard,
  onCardSelected,
  validateCreditCard,
}): JSX.Element => (
  <div className="w-full md:w-[411px] mt-[14px]">
    <div className="flex flex-col justify-between">
      <div className="space-y-5 ">
        {controllerCreditCard.list.length === 0 ? (
          <div className="text-base font-dmsans font-normal text-neutro-w-600">
            Você ainda não tem um cartão de crédito cadastrado
            <br />
            <br /> Clique no botão <strong>“Adicionar novo cartão”</strong> para cadastrar um cartão
            de crédito.
          </div>
        ) : (
          ''
        )}

        <CardCheckoutContent
          id={id}
          payment={payment}
          card={card}
          totalValue={totalValue}
          showValue={showValue}
          controllerCreditCard={controllerCreditCard}
          onChange={onChange}
          toCurrency={toCurrency}
          onCardSelected={onCardSelected}
          validateCreditCard={validateCreditCard}
        />
      </div>
    </div>
  </div>
);
